import React,{useEffect} from 'react';
import { connect } from 'react-redux';
import {setGlobalLanguage} from '../actions/i18n.action';
import {LOCALES} from '../i18n/constants';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import TranslateIcon from '@material-ui/icons/Translate';

function SimpleMenu (props) {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  useEffect(()=>{
    const lang= localStorage.getItem('i18nLanguage')
    if(lang) props.seti18n(lang)
  },[])

  return (
    <>
      <Button 
        aria-controls="simple-menu" 
        aria-haspopup="true" 
        color='primary'
        variant='outlined'
        startIcon={<TranslateIcon/>}
        onClick={handleClick}>
        Language
      </Button>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {Object.keys(LOCALES).map(lang => (
          <MenuItem 
            key={lang} 
            onClick={() => {
              props.seti18n(LOCALES[lang]);
              handleClose();
            }}>{lang}</MenuItem>
        ))}
      </Menu>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    _id:state.authReducer.user._id,
  };
};
 
const mapDispatchToProps = (dispatch) => {
  return {
    seti18n: (language) => dispatch(setGlobalLanguage(language)),
  };
};
 
export default connect(mapStateToProps, mapDispatchToProps)(SimpleMenu);
